export default __webpack_public_path__ + "static/media/Sanatan.8c163be7f9b2501ae52d386f84ef7534.webp";